import styled, { css } from 'styled-components'

import {
  SizeSelector as LMFSizeSelector,
  TypeStyle,
  fromMd,
  timingDefault,
  untilMd,
  withHoverSupport,
  zIndexForeground,
} from '@syconium/little-miss-figgy'

import { EmbroiderySelector as OriginalEmbroiderySelector } from '../../../../../../../../components/quick-buy/EmbroiderySelector'
const overlayHeightPixels = 40

export const StepSlider = styled.div<{
  offsetPixels: number
}>`
  transform: translateY(${o => -o.offsetPixels}px);
  transition: transform ${timingDefault} ease;
`

export const Cta = styled.button<{ isUppercase?: boolean }>`
  ${TypeStyle.css.headlineMicro}
  align-items: center;
  display: flex;
  height: ${overlayHeightPixels}px;
  justify-content: center;
  text-transform: uppercase;
  width: 100%;

  ${untilMd} {
    font-size: 11px;
  }

  &:hover {
    text-decoration: underline;
  }
`

const SelectorWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
`

export const FitSelectorWrapper = styled(SelectorWrapper)`
  padding-top: 12px;
  padding-bottom: 6px;
`

export const SizeSelector = styled(LMFSizeSelector)`
  justify-content: ${o => (o.minWidthStyle === 'lg' ? 'center' : 'start')};
  max-width: ${o => (o.minWidthStyle === 'lg' && '338px') || (o.minWidthStyle === 'md' && '226px')};

  ${fromMd} {
    justify-content: ${o => o.minWidthStyle === 'lg' && 'center'};
    margin-top: 0;
    margin-bottom: -8px;
    margin-inline-start: 0;
    margin-inline-end: -8px;
  }
`

export const SizeSelectorWrapper = styled(SelectorWrapper)<{ extendedFixedWidthItems?: boolean }>`
  padding: ${o => (o.extendedFixedWidthItems ? '12px 14px' : '12px 28px')};
`

export const EmbroiderySelectorWrapper = styled.div``

export const EmbroiderySelector = styled(OriginalEmbroiderySelector)`
  padding: 20px;
`

export const AddingIndicator = styled.div`
  align-items: center;
  display: flex;
  font-weight: 600;
  height: ${overlayHeightPixels}px;
  justify-content: center;
`

export const LoadingSpinnerWrapper = styled.div`
  margin-right: 12px;
`

export const QuickBuyStepsContainer = styled.div<{ isVisible?: boolean }>`
  visibility: ${o => (o.isVisible !== undefined && !o.isVisible ? 'hidden' : 'visible')};
`

export const Body = styled(TypeStyle.HeadlineMicro)<{
  $ctaOnly: boolean
  $hasBegunQuickBuyExperience: boolean
  $heightPixels?: number
  $hideOnDesktop: boolean
  $isFavorites?: boolean
  $useLargeWidthSizeSelectorItems?: boolean
  $isVariant: boolean
}>`
  bottom: 0;
  cursor: pointer;
  justify-content: center;
  opacity: 1;
  overflow: hidden;
  position: absolute;
  transition-property: height, opacity;
  transition-duration: ${timingDefault};
  transition-timing-function: ease;
  z-index: ${zIndexForeground};
  visibility: ${o => o.$isFavorites && 'hidden'};

  ${withHoverSupport} {
    ${o =>
      o.$useLargeWidthSizeSelectorItems &&
      !o.$ctaOnly &&
      css`
        height: 431px;
      `};
  }

  @media screen and (max-width: 1200px) {
    ${SizeSelectorWrapper} {
      margin-top: 50%;
      padding: 86px 8px 45px 8px;
    }
    ${SizeSelector} {
      max-width: 170px;
      max-height: 280px;
      margin-top: 42%;
      overflow-y: scroll;
      -ms-overflow-style: none;

      ::-webkit-scrollbar {
        display: none;
      }
    }
  }
  /**
   * overlay on desktop is visible:
   * - on product tile hover (if hover is supported)
   * - when the flow is started
   * - If being used on the favorites page (hidden on mobile)
   * - if hideOnDesktop is false
   */
  ${withHoverSupport} {
    pointer-events: ${o => o.$hideOnDesktop && !o.$isVariant && 'none'};
    visibility: ${o => (!o.$hasBegunQuickBuyExperience ? 'hidden' : 'visible')};
  }

  ${untilMd} {
    font-size: 11px;
    height: ${o => o.theme.spacing(8)};
    width: ${o => o.theme.spacing(8)};
    bottom: ${o => o.theme.spacing(2)};
    right: ${o => o.theme.spacing(2)};
  }

  ${fromMd} {
    ${o =>
      !o.$isVariant
        ? `
    visibility: ${o.$hideOnDesktop && 'hidden'};
    background: rgba(255, 255, 255, 0.8);
    left: 0;
    right: 0;
    height: ${o.$heightPixels ?? overlayHeightPixels}px;
    `
        : `height: ${o.theme.spacing(8)};
    width: ${o.theme.spacing(8)};
    bottom: ${o.theme.spacing(4)};
    right: ${o.theme.spacing(4)};`}
  }
`

export const MobileQuickBuyButton = styled.button`
  position: absolute;
  height: ${o => o.theme.spacing(8)};
  width: ${o => o.theme.spacing(8)};
  bottom: ${o => o.theme.spacing(2)};
  right: ${o => o.theme.spacing(2)};
`
